import findAllFor from '../filters/find-all-for';
import view from '../../view';
import isNumeric from '../../../utils/is-numeric';

const getCloneConstraintForElement = (element) => {
  const constraints = findAllFor(element);
  const liveDocument = view.accessors.getLiveDocument();

  return constraints.find((constraint) => {
    if (isNumeric(constraint.maxCount)) {
      return (
        constraint.cloneable &&
        liveDocument.querySelectorAll(constraint.element).length < constraint.maxCount
      );
    }

    return constraint.cloneable;
  });
};

export default getCloneConstraintForElement;
